import $ from 'jquery';
import 'slick-carousel';
import isElement from '../../scripts/util/isElement';

const selectors = {
	reviews: '.js--reviews__slider',
	slider: '.js--reviews-slider',
	nav: '.js--reviews-slider-nav',
	imagesSite: '.js--reviews-slider-image-site'
};

const time = 750;
const VIEW_MOBILE_SIZE = 1024;

const reviewsSettings = {
	arrows: false,
	infinite: true,
	dots: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	speed: time,
	fade: true,
	adaptiveHeight: false,
	waitForAnimate: false,
	asNavFor: selectors.nav
};

const reviewsNavSettings = {
	prevArrow: '<div class= "reviews-slider__arrow mod--type-left"><svg width="33" height="18" viewBox="0 0 33 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.9836 9H1.98364" stroke="#E5E1D6" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/><path d="M7.88525 16L1 9L7.88525 2" stroke="#E5E1D6" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/></svg></div>',
	nextArrow: '<div class= "reviews-slider__arrow mod--type-right"><svg width="33" height="18" viewBox="0 0 33 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.01636 9L31.0164 9" stroke="#E5E1D6" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/><path d="M25.1148 2L32 9L25.1148 16" stroke="#E5E1D6" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/></svg></div>',
	infinite: true,
	dots: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	speed: time,
	fade: true,
	adaptiveHeight: false,
	waitForAnimate: false,
	asNavFor: selectors.slider,
	responsive: [{
		breakpoint: VIEW_MOBILE_SIZE,
		settings: {
			slidesToShow: 1,
			dots: false,
			touchThreshold: 5,
			swipeToSlide: true,
			waitForAnimate: true,
			cssEase: 'ease',
			speed: 500,
			edgeFriction: 0.5,
			adaptiveHeight: true
		}
	}]
};

const reviewsSlickCarousel = (settings, settingsNav) => {
	const slider = $(selectors.slider);
	const sliderNav = $(selectors.nav);

	slider.slick(settings);
	sliderNav.slick(settingsNav);

	slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$(selectors.imagesSite).attr('data-active', `slide-active-${nextSlide}`);

		if ($(window).width() > VIEW_MOBILE_SIZE) {
			$(selectors.reviews).addClass('is--disabled');
		}
	});

	sliderNav.on('afterChange', function (event, slick, currentSlide) {
		setTimeout(function () {
			sliderNav.attr('data-slide-active', `slide-active-${currentSlide}`);

			$(selectors.imagesSite).find('.slide-img.is--active').removeClass('is--active');
			$(selectors.imagesSite).find(`.for-slide-${currentSlide}`).addClass('is--active');
			$(selectors.reviews).removeClass('is--disabled');
		}, 100);
	});
};

const render = () => {
	if (isElement(selectors.slider)) {
		reviewsSlickCarousel(reviewsSettings, reviewsNavSettings);
	}
};

export default render;
